const configErrors = {
  'jobTask.alreadyExistsInCompany': {
    name: 'errors.jobsTasksExisting',
  },
};

export default configErrors;
